export const betradarStreamStatuses = {
  ON_AIR_BROADCAST: 'On Air Broadcast',
};

export const betradarStatusesWithStreamingLive = [betradarStreamStatuses.ON_AIR_BROADCAST];

export const PLACEHOLDER_STREAM_URL = 'PLACEHOLDER_STREAM_URL';
